import { ComponentMeta, ComponentStory, Story } from "@storybook/react";
import React, { CSSProperties } from "react";
import Block from "./Block";
import Flex from "../Flex";
import { theme } from "../../theme";

const preCodeStyle: CSSProperties = {
    display: "inline",
    backgroundColor: "#ededed",
    padding: "2px 4px",
    borderRadius: 4
};

type StoryWithActions = ComponentStory<typeof Block>;

export default {
    title: "common/Block",
    component: Block,
    args: {
        actions: "Actions",
        header: "Header"
    },
    parameters: {
        backgrounds: {
            default: "layout",
            values: [
                {
                    name: "layout",
                    value: theme.light.colors["surface-25"]
                }
            ]
        }
    }
} as ComponentMeta<typeof Block>;

const Template: StoryWithActions = args => <Block {...args} style={{ height: 500 }} />;

export const Default = Template.bind({});

export const LayoutExample: Story = () => (
    <Flex width="100%" spacing={4}>
        <Block style={{ height: 1000 }}>Main information</Block>
        <Flex column width="280px" spacing={2.5}>
            <Block style={{ height: 290 }}>Extra information</Block>
            <Block style={{ height: 180 }}>Extra information</Block>
        </Flex>
    </Flex>
);

export const LayoutExampleWithoutContainerStyles: Story = () => (
    <Flex width="100%" spacing={4}>
        <Block withoutContainerStyles style={{ height: 1000 }}>
            Main information
        </Block>
        <Flex column width="280px" spacing={2.5}>
            <Block withoutContainerStyles style={{ height: 290 }}>
                Extra information
            </Block>
            <Block withoutContainerStyles style={{ height: 180 }}>
                Extra information
            </Block>
        </Flex>
    </Flex>
);

export const WithHeader: Story = () => (
    <Block header="Main information">
        <div style={{ height: 300 }}>Extra information</div>
    </Block>
);

export const WithHeaderAndActionsNoWrap: Story = () => (
    <Block
        actions="The actions"
        header="The header can be any React component, and occupy a lot of horizontal space"
        headerWrap="nowrap"
        style={{ maxWidth: 500 }}
    >
        <p>
            By passing the <pre style={preCodeStyle}>headerWrap</pre> prop, we can customize how the header and actions
            wrap. By default, actions will go on a new line if the header needs the whole width of the Block.
        </p>{" "}
        <p>
            By passing <pre style={preCodeStyle}>nowrap</pre>, like in this example, the actions and title remains side
            by side. You can play more with different combinations in the Default story.
        </p>
    </Block>
);

export const CollapsibleBlock: Story = () => (
    <Block header="Main information" collapsible>
        <div style={{ height: 300 }}>Extra information</div>
    </Block>
);

export const NestedBlock: Story = () => (
    <Block header="Parent block">
        <Flex column spacing={3}>
            <div>Parent block information</div>
            <Block header="Nested block">
                <div style={{ height: 100 }}>Nested block information</div>
            </Block>
        </Flex>
    </Block>
);
